import type { ManuallyClaimingUnitKind } from "@/souhl_admin/gql/__generated__/graphql"

export const maxFeeAmount = 100_000
export const minFeeAmount = 1
export const maxFeePercent = 100
export const minFeePercent = 1

export const cancelFeeTypeForNonZeroYenReservationKey = {
	PERCENT: "PERCENT",
	AMOUNT: "AMOUNT",
} as const

export type CancelFeeTypeForNonZeroCalculateKey =
	keyof typeof cancelFeeTypeForNonZeroYenReservationKey

export const cancelFeeTypeForNonZeroYenReservationKeyArray = Object.keys(
	cancelFeeTypeForNonZeroYenReservationKey
).map((key) => key as CancelFeeTypeForNonZeroCalculateKey)

export const cancelFeeTypeForNonZeroYenReservationLabel = {
	[cancelFeeTypeForNonZeroYenReservationKey.PERCENT]: "％指定",
	[cancelFeeTypeForNonZeroYenReservationKey.AMOUNT]: "固定金額",
} as const

// 手動請求の来店回数区間 unit の「何に転換するか」の一覧 (select の選択肢の順)
export const manuallyClaimingUnitKinds: ManuallyClaimingUnitKind[] = [
	"ENCOURAGE_CONVERSION",
]

// 手動請求の来店回数区間 unit の「何に転換するか」の表示名
export const manuallyClaimingUnitKindLabel: Record<
	ManuallyClaimingUnitKind,
	string
> = {
	ENCOURAGE_CONVERSION: "再予約転換",
}

// 「何に転換するか × 転換日数」の表示文言 (編集 select の選択肢と閲覧表示で共通)
export const formatManuallyClaimingConversion = (conversion: {
	manuallyClaimingUnitKind: ManuallyClaimingUnitKind | null
	conversionDays: number | null
}): string => {
	if (conversion.manuallyClaimingUnitKind === null) {
		return "通常の手動請求 (転換しない)"
	}
	return `キャンセル ${conversion.conversionDays} 日後に${
		manuallyClaimingUnitKindLabel[conversion.manuallyClaimingUnitKind]
	}`
}

// unit の種別ごとに選べる転換日数 (キャンセル日から何日後に転換するか)
// backend の ManuallyClaimingUnitKind.allowed_conversion_days と揃えること。ズレると保存時にバリデーションで弾かれる
export const selectableConversionDaysByManuallyClaimingUnitKind: Record<
	ManuallyClaimingUnitKind,
	number[]
> = {
	ENCOURAGE_CONVERSION: [3, 5, 7, 14, 21],
}
